import React from 'react';
import {partenaireColor} from "../data";

const PartenaireBadge = ({nom}: { nom: string }) => {

  const getPartenaireColor = (nom) => {
    return partenaireColor
      .find((partenaire) => partenaire?.label?.toLowerCase() === nom?.toLowerCase());
  }

    if (!nom) return null;

  return (
    <span
      className="inline-flex px-2.5 py-1 text-xs font-medium rounded-full text-white mr-1 mb-1"
      style={{
        backgroundColor: getPartenaireColor(nom)?.couleur || '#4B5563',
      }}
    >
      {nom}
    </span>
    );
};

export default PartenaireBadge;